function fetchJSONP(url) {
  const script = document.createElement("script");
  script.src = url;
  document.body.appendChild(script);
}

function jsonpCallback(params) {
  console.log("params", params.result, params.msg);
  if (params.result == "error") {
    successResponseEl.classList.add("hidden");
    errorResponseEl.classList.remove("hidden");
    // errorResponseEl.innerHTML = params.msg;
  } else {
    successResponseEl.classList.remove("hidden");
    errorResponseEl.classList.add("hidden");
    // successResponseEl.innerHTML = params.msg;
    event.target.querySelector('[type="email"]').value = "";
  }
}

var submitForms = document.querySelectorAll(".mc-embedded-subscribe-form");
var checkboxElAll = document.getElementsByName("form-checkbox");
var termsPrivacyEl = document.querySelector(".terms-privacy");
var errorResponseEl = document.querySelector(".mce-error-response");
var successResponseEl = document.querySelector(".mce-success-response");
checkboxElAll.forEach((item) => {
  item.addEventListener("click", function (event) {
    let target = event.target;
    activeEl(target.checked, event.target);
  });
});

function activeEl(show, el) {
  if (show) {
    el.classList.remove("active");
    termsPrivacyEl.classList.add("hidden");
  } else {
    el.classList.add("active");
    termsPrivacyEl.classList.remove("hidden");
  }
}
if (submitForms.length > 0) {
  submitForms.forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      var timestamp = new Date().getTime();

      var emailValue = event.target.querySelector('[type="email"]').value;

      if (emailValue == "") return;
      var checkboxEl = event.target.querySelector('[type="checkbox"]');
      var checkboxOff = checkboxEl.checked;

      activeEl(checkboxOff, checkboxEl);
      if (!checkboxOff) return;
      var url = event.target.getAttribute("action");
      url = url.replace("/post?u=", "/post-json?u=");
      url += "&c=jsonpCallback";
      url += "&EMAIL=" + emailValue;
      if(errorResponseEl){errorResponseEl.classList.add("hidden");}
      if(successResponseEl){successResponseEl.classList.add("hidden");}
      

      fetchJSONP(url);
    });
  });
}
